/* 注意事項
   汎用機能（screenLockやopenMessageDialog）を利用しているため単独利用の際はこれらも導入すること
   addEventListenerの実行順がB2Bアプリやその他submitイベントよりも先に来る必要があるので読み込み位置等調整すること
   CM利用時は定数「isUseCm」を切り替える=>テーマエディタに移行
*/

// 基本設定

let is_use_cm = document.getElementById('is_use_cm'); // CM使用するかどうか 
let delivery_required_select_days = document.getElementById('ill-delivery_required_select_days').value; // 日付選択必須にするか
let delivery_required_select_times = document.getElementById('ill-delivery_required_select_times').value; // 時間帯付選択必須にするか 
let delivery_date_select = document.getElementById('deliveryDate'); // 配送希望日serect
let delivery_time_select = document.getElementById('deliveryTime'); // 配送希望時間帯serect
let delivery_days_head = document.getElementById('delivery_days_head'); // 配送希望日ラベル
let delivery_times_head = document.getElementById('delivery_times_head'); // 配送希望時間帯ラベル
// CM利用時の指定key名
if (is_use_cm == "true"){
  delivery_days_head = "配送希望日";
  delivery_times_head= "配送時間帯";
}
let is_delivery_no_specified = document.getElementById('ill-delivery_no-specified').value; // 指定なし文言が入っているか
let select_first_option = null;
if(is_delivery_no_specified){
  if(is_delivery_no_specified == "true"){
    select_first_option = delivery_date_select.options[2]; // 入ってたら3つめが最短(未選択、指定なし、希望日)
  }else{
    select_first_option = delivery_date_select.options[1]; // 入ってなければ2つめが最短(未選択、希望日)
  }
}

// 配送希望日時の変更時に実行
delivery_date_select.addEventListener('change', (event) => {
  delivery_date_select.style.textDecoration = "auto"; // 打消し線がついていたら消す
  updateCartAttribute([{key: delivery_days_head.value, value: event.target.value}]); // 日時追加
});

delivery_time_select.addEventListener('change', (event) => {
  updateCartAttribute([{key:delivery_times_head.value, value: event.target.value}]); // 時間追加
});

// cart submitのタイミングで最短選択＆締め時間を跨いでいた場合にメッセージ
document.getElementById("cart").addEventListener('submit', function(event) {
  try {
    screenLock(document.querySelector("#checkout")); // アイルアプリ汎用メソッド
    let default_option_value = document.getElementById('ill-delivery_no-select_text').value;
    // 選択必須＆配送日時が選択されていなければメッセージを出して停止
    if(delivery_required_select_days == "true"  && delivery_date_select.value == default_option_value){ 
      openMessageDialog(document.getElementById('ill-delivery_no-select-msg').value); // アイルアプリ汎用メソッド
      event.stopPropagation();
      event.preventDefault();
      screenUnlock(); // アイルアプリ汎用メソッド
      return;
    }
    // 選択必須＆配送日時が選択されていなければメッセージを出して停止
    if(delivery_required_select_times == "true" && delivery_time_select.value == default_option_value){ 
      openMessageDialog(document.getElementById('ill-delivery_no-select-msg').value); // アイルアプリ汎用メソッド
      event.stopPropagation();
      event.preventDefault();
      screenUnlock(); // アイルアプリ汎用メソッド
      return;
    }
    const japanStandardTime = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000)); //日本時間
    // 締め時間が存在しなければ何もしない
    let cutoff_hour = parseInt(document.getElementById('cutoff_hour').value, 10);
    let cutoff_minute = parseInt(document.getElementById('cutoff_minute').value, 10);
    if(!cutoff_hour||!cutoff_minute){
      screenUnlock(); // アイルアプリ汎用メソッド
      return;
    }
    // 締め時間を過ぎていなければ何もしない
    let now_hour = japanStandardTime.getHours();
    let now_minute = japanStandardTime.getMinutes();
    if(cutoff_hour > now_hour){
      screenUnlock(); // アイルアプリ汎用メソッド
      return;
    }else if(cutoff_hour==now_hour && cutoff_minute > now_minute){
      screenUnlock(); // アイルアプリ汎用メソッド
      return;
    }
    // liquid上で既に締め時間を過ぎている場合は古い選択肢が出ないので何もしない
    let is_time_over = document.getElementById('is_time_over').value; // liquid上で締め日を過ぎた場合だけtrue
    if(is_time_over == "true"){
      screenUnlock(); // アイルアプリ汎用メソッド
      return;
    }
    // そもそも時間帯が選択されていなければ何もしない
    let cart = JSON.parse(getCart()); // アイルアプリ汎用メソッド
    let cart_delivery_days = cart.attributes[delivery_days_head.value]; // カートattributeから選択された時間帯を取得
    if(!cart_delivery_days){
      screenUnlock(); // アイルアプリ汎用メソッド
      return;
    }
    // liquid上では締め日を過ぎてないが、時間経過で締め時間が過ぎ、かつ選択が最短であった場合にメッセージ
    if(select_first_option.value == cart_delivery_days){
      select_first_option.disabled = true; // 最短配送日を選択不可にする
      delivery_date_select.style.textDecoration = "line-through"; // 打消し線
      openMessageDialog(document.getElementById('ill-delivery_limit_over-msg').value); // アイルアプリ汎用メソッド
      event.stopPropagation();
      event.preventDefault();
      screenUnlock(); // アイルアプリ汎用メソッド
      return;
    }
  } catch (error) {
    console.log(error);
    screenUnlock(); // アイルアプリ汎用メソッド
    return;
  }
},true); //B2BのsubmitのaddEventListenerより先に順番を持ってくる

// cartAttributeに配送日時追加
// 引数は[{key: "", value: ""}, ...]]形式
// 自由入力させた値を用いる場合はインジェクションされないように手前でstring型にしておくこと
function updateCartAttribute(attributes) {
  screenLock(document.querySelector("#checkout")); // アイルアプリ汎用メソッド
  const formData = new FormData();
  for (let attribute of attributes) {
    formData.append(`attributes[${attribute.key}]`, attribute.value);
  }
  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    body: formData
  })
  .then(response => response.json())
  .then(data => {
    console.log('Cart attributes updated:', data.attributes);
    screenUnlock(); // アイルアプリ汎用メソッド
  })
  .catch(error => {
    console.error('Error updating cart attributes:', error);
    screenUnlock(); // アイルアプリ汎用メソッド
  });
}

//Dataフォーマットを指定フォーマットに変換
// %y:年 %m:月 %d:日 %a:曜日 
function getDateFormat(date, format){
  let y = date.getFullYear();
  let m = ("00" + (date.getMonth()+1)).slice(-2);
  let d = ("00" + (date.getDate())).slice(-2);
  let a = getDayJp(date.getDay());
  return format.replace("%y",y).replace("%m",m).replace("%d",d).replace("%a",a);
}

//data型を曜日に変換
function getDayJp(wday){
  if(wday == 0){
    return "日"
  }else if(wday == 1){
    return "月"
  }else if(wday == 2){
    return "火"
  }else if(wday == 3){
    return "水"
  }else if(wday == 4){
    return "木"
  }else if(wday == 5){
    return "金"
  }else if(wday == 6){
    return "土"
  }
}